import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function WorliMatka() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
   const VIDEO_ID = "worli"
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);


  return (
      <CasinoPage
              casino={casinoData?.data}
              VIDEO_ID={VIDEO_ID}
              // VIDEO_ID={GAME_ID}
              GAME_ID={GAME_ID}
              // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
              //  VIDEO_ID={GAME_ID}
              // GAME_ID={GAME_ID}
              // shortName={"cards32a cards32b"}
              // gameName={"CARDS 32B"}
            >
    {/* <div className="center-main-container casino-page"> */}
  {/* <div className="center-container"> */}
    {/* <div className="casino-page-container worli"> */}
      {/* <div className="casino-header"> */}
        {/* <span className="casino-name">Worli Matka</span> */}
        {/* <span className="casino-rid d-none d-xl-inline-block">
          <small>
            Round ID: <span>126250507125525</span>
          </small>
        </span> */}
      {/* </div> */}
      {/* <div className="casino-title-header-mobile d-xl-none">
        <ul className="nav nav-tabs menu-tabs">
          <li className="nav-item">
            <div className="nav-link active">Game</div>
          </li>
          <li className="nav-item">
            <div className="nav-link">Placed Bet (0)</div>
          </li>
        </ul>
        <div className="pe-2">
          <span className="casino-rid">
            Round ID: <span>126250507125525</span>
          </span>
        </div>
      </div> */}
      {/* <div className=""> */}
        {/* <div className="casino-video">
          <div className="video-box-container">
            <div className="casino-video-box">
            </div>
          </div>
          <div className="casino-video-cards">
            <div className="">
              <div className="flip-card-container">
                <div className="flip-card">
                  <div className="flip-card-inner ">
                    <div className="flip-card-front">
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                    </div>
                    <div className="flip-card-back">
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                    </div>
                  </div>
                </div>
                <div className="flip-card">
                  <div className="flip-card-inner ">
                    <div className="flip-card-front">
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                    </div>
                    <div className="flip-card-back">
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                    </div>
                  </div>
                </div>
                <div className="flip-card">
                  <div className="flip-card-inner ">
                    <div className="flip-card-front">
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                    </div>
                    <div className="flip-card-back">
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="clock flip-clock-wrapper">
            <ul className="flip play">
              <li className="flip-clock-before">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">6</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">6</div>
                  </div>
                </a>
              </li>
              <li className="flip-clock-active">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">5</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">5</div>
                  </div>
                </a>
              </li>
            </ul>
            <ul className="flip play">
              <li className="flip-clock-before">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">3</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">3</div>
                  </div>
                </a>
              </li>
              <li className="flip-clock-active">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">2</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">2</div>
                  </div>
                </a>
              </li>
            </ul>
          </div> */}
     
        <div className="casino-detail">
          <div className="casino-table">
            <div className="nav nav-pills" role="tablist">
              <div className="nav-item">
                <a
                  role="tab"
                  data-rr-ui-event-key="single"
                  id="worli-tabs-tab-single"
                  aria-controls="worli-tabs-tabpane-single"
                  aria-selected="true"
                  className="nav-link active"
                  tabIndex={0}
                  href="#"
                >
                  Single
                </a>
              </div>
              <div className="nav-item">
                <a
                  role="tab"
                  data-rr-ui-event-key="pana"
                  id="worli-tabs-tab-pana"
                  aria-controls="worli-tabs-tabpane-pana"
                  aria-selected="false"
                  tabIndex={-1}
                  className="nav-link"
                  href="#"
                >
                  Pana
                </a>
              </div>
              <div className="nav-item">
                <a
                  role="tab"
                  data-rr-ui-event-key="sp"
                  id="worli-tabs-tab-sp"
                  aria-controls="worli-tabs-tabpane-sp"
                  aria-selected="false"
                  tabIndex={-1}
                  className="nav-link"
                  href="#"
                >
                  SP
                </a>
              </div>
              <div className="nav-item">
                <a
                  role="tab"
                  data-rr-ui-event-key="dp"
                  id="worli-tabs-tab-dp"
                  aria-controls="worli-tabs-tabpane-dp"
                  aria-selected="false"
                  tabIndex={-1}
                  className="nav-link"
                  href="#"
                >
                  DP
                </a>
              </div>
              <div className="nav-item">
                <a
                  role="tab"
                  data-rr-ui-event-key="trio"
                  id="worli-tabs-tab-trio"
                  aria-controls="worli-tabs-tabpane-trio"
                  aria-selected="false"
                  tabIndex={-1}
                  className="nav-link"
                  href="#"
                >
                  Trio
                </a>
              </div>
              <div className="nav-item">
                <a
                  role="tab"
                  data-rr-ui-event-key="cycle"
                  id="worli-tabs-tab-cycle"
                  aria-controls="worli-tabs-tabpane-cycle"
                  aria-selected="false"
                  tabIndex={-1}
                  className="nav-link"
                  href="#"
                >
                  Cycle
                </a>
              </div>
              <div className="nav-item">
                <a
                  role="tab"
                  data-rr-ui-event-key="motor"
                  id="worli-tabs-tab-motor"
                  aria-controls="worli-tabs-tabpane-motor"
                  aria-selected="false"
                  tabIndex={-1}
                  className="nav-link"
                  href="#"
                >
                  Motor SP
                </a>
              </div>
              <div className="nav-item">
                <a
                  role="tab"
                  data-rr-ui-event-key="chart56"
                  id="worli-tabs-tab-chart56"
                  aria-controls="worli-tabs-tabpane-chart56"
                  aria-selected="false"
                  tabIndex={-1}
                  className="nav-link"
                  href="#"
                >
                  56 Charts
                </a>
              </div>
              <div className="nav-item">
                <a
                  role="tab"
                  data-rr-ui-event-key="chart64"
                  id="worli-tabs-tab-chart64"
                  aria-controls="worli-tabs-tabpane-chart64"
                  aria-selected="false"
                  tabIndex={-1}
                  className="nav-link"
                  href="#"
                >
                  64 Charts
                </a>
              </div>
              <div className="nav-item">
                <a
                  role="tab"
                  data-rr-ui-event-key="abr"
                  id="worli-tabs-tab-abr"
                  aria-controls="worli-tabs-tabpane-abr"
                  aria-selected="false"
                  tabIndex={-1}
                  className="nav-link"
                  href="#"
                >
                  ABR
                </a>
              </div>
              <div className="nav-item">
                <a
                  role="tab"
                  data-rr-ui-event-key="commonsp"
                  id="worli-tabs-tab-commonsp"
                  aria-controls="worli-tabs-tabpane-commonsp"
                  aria-selected="false"
                  tabIndex={-1}
                  className="nav-link"
                  href="#"
                >
                  Common SP
                </a>
              </div>
              <div className="nav-item">
                <a
                  role="tab"
                  data-rr-ui-event-key="commondp"
                  id="worli-tabs-tab-commondp"
                  aria-controls="worli-tabs-tabpane-commondp"
                  aria-selected="false"
                  tabIndex={-1}
                  className="nav-link"
                  href="#"
                >
                  Common DP
                </a>
              </div>
              <div className="nav-item">
                <a
                  role="tab"
                  data-rr-ui-event-key="colordp"
                  id="worli-tabs-tab-colordp"
                  aria-controls="worli-tabs-tabpane-colordp"
                  aria-selected="false"
                  tabIndex={-1}
                  className="nav-link"
                  href="#"
                >
                  Color DP
                </a>
              </div>
            </div>
            <div className="tab-content">
              <div
                role="tabpanel"
                id="worli-tabs-tabpane-single"
                aria-labelledby="worli-tabs-tab-single"
                className="fade single tab-pane active show"
              >
                <div className="worlibox">
                  <div className="worli-left">
                    <div className="worli-box-title">
                      <b>9.5</b>
                    </div>
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">1</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">2</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">3</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">4</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">5</span>
                      </div>
                    </div>
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">6</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">7</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">8</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">9</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">0</span>
                      </div>
                    </div>
                  </div>
                  <div className="worli-right">
                    <div className="worli-box-title">
                      <b>9.5</b>
                    </div>
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">Line 1</span>
                        <span className="d-block">1|2|3|4|5</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">ODD</span>
                        <span className="d-block">1|3|5|7|9</span>
                      </div>
                    </div>
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">Line 2</span>
                        <span className="d-block">6|7|8|9|0</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">EVEN</span>
                        <span className="d-block">2|4|6|8|0</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                role="tabpanel"
                id="worli-tabs-tabpane-pana"
                aria-labelledby="worli-tabs-tab-pana"
                className="fade pana tab-pane"
              >
                <div className="worli-full">
                  <div className="worli-box-title" />
                  <div className="worli-box-row">
                    <div className="worli-odd-box back">
                      <span className="worli-odd">1</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">2</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">3</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">4</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">5</span>
                    </div>
                  </div>
                  <div className="worli-box-row">
                    <div className="worli-odd-box back">
                      <span className="worli-odd">6</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">7</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">8</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">9</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">0</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                role="tabpanel"
                id="worli-tabs-tabpane-sp"
                aria-labelledby="worli-tabs-tab-sp"
                className="fade sp tab-pane"
              >
                <div className="worlibox">
                  <div className="worli-box-title" />
                  <div className="worli-left">
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">1</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">2</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">3</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">4</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">5</span>
                      </div>
                    </div>
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">6</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">7</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">8</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">9</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">0</span>
                      </div>
                    </div>
                  </div>
                  <div className="worli-right">
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">SP ALL</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                role="tabpanel"
                id="worli-tabs-tabpane-dp"
                aria-labelledby="worli-tabs-tab-dp"
                className="fade dp tab-pane"
              >
                <div className="worlibox">
                  <div className="worli-box-title" />
                  <div className="worli-left">
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">1</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">2</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">3</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">4</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">5</span>
                      </div>
                    </div>
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">6</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">7</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">8</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">9</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">0</span>
                      </div>
                    </div>
                  </div>
                  <div className="worli-right">
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">DP ALL</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                role="tabpanel"
                id="worli-tabs-tabpane-trio"
                aria-labelledby="worli-tabs-tab-trio"
                className="fade trio tab-pane"
              >
                <div className="worli-full">
                  <div className="worli-box-title" />
                  <div className="worli-box-row">
                    <div className="worli-odd-box back">
                      <span className="worli-odd">ALL TRIO</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                role="tabpanel"
                id="worli-tabs-tabpane-cycle"
                aria-labelledby="worli-tabs-tab-cycle"
                className="fade cycle tab-pane"
              >
                <div className="worli-full">
                  <div className="worli-box-title">
                    <b>&nbsp;</b>
                  </div>
                  <div className="worli-box-row">
                    <div className="worli-odd-box back">
                      <span className="worli-odd">1</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">2</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">3</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">4</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">5</span>
                    </div>
                  </div>
                  <div className="worli-box-row">
                    <div className="worli-odd-box back">
                      <span className="worli-odd">6</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">7</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">8</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">9</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">0</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                role="tabpanel"
                id="worli-tabs-tabpane-motor"
                aria-labelledby="worli-tabs-tab-motor"
                className="fade motorsp tab-pane"
              >
                <div className="worli-full">
                  <div className="worli-box-title" />
                  <div className="worli-box-row">
                    <div className="worli-odd-box back">
                      <span className="worli-odd">1</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">2</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">3</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">4</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">5</span>
                    </div>
                  </div>
                  <div className="worli-box-row">
                    <div className="worli-odd-box back">
                      <span className="worli-odd">6</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">7</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">8</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">9</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">0</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                role="tabpanel"
                id="worli-tabs-tabpane-chart56"
                aria-labelledby="worli-tabs-tab-chart56"
                className="fade chart56 tab-pane"
              >
                <div className="worlibox">
                  <div className="worli-box-title" />
                  <div className="worli-left">
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">1</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">2</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">3</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">4</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">5</span>
                      </div>
                    </div>
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">6</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">7</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">8</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">9</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">0</span>
                      </div>
                    </div>
                  </div>
                  <div className="worli-right">
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">56 ALL</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                role="tabpanel"
                id="worli-tabs-tabpane-chart64"
                aria-labelledby="worli-tabs-tab-chart64"
                className="fade chart64 tab-pane"
              >
                <div className="worlibox">
                  <div className="worli-box-title" />
                  <div className="worli-left">
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">1</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">2</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">3</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">4</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">5</span>
                      </div>
                    </div>
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">6</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">7</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">8</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">9</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">0</span>
                      </div>
                    </div>
                  </div>
                  <div className="worli-right">
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">64 ALL</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                role="tabpanel"
                id="worli-tabs-tabpane-abr"
                aria-labelledby="worli-tabs-tab-abr"
                className="fade abr tab-pane"
              >
                <div className="worlibox">
                  <div className="worli-box-title" />
                  <div className="worli-left">
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">A</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">B</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">R</span>
                      </div>
                    </div>
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">AB</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">AR</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">BR</span>
                      </div>
                    </div>
                  </div>
                  <div className="worli-right">
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">ABR</span>
                      </div>
                    </div>
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">ABR CUT</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                role="tabpanel"
                id="worli-tabs-tabpane-commonsp"
                aria-labelledby="worli-tabs-tab-commonsp"
                className="fade commonsp tab-pane"
              >
                <div className="worli-full">
                  <div className="worli-box-title" />
                  <div className="worli-box-row">
                    <div className="worli-odd-box back">
                      <span className="worli-odd">1</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">2</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">3</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">4</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">5</span>
                    </div>
                  </div>
                  <div className="worli-box-row">
                    <div className="worli-odd-box back">
                      <span className="worli-odd">6</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">7</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">8</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">9</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">0</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                role="tabpanel"
                id="worli-tabs-tabpane-commondp"
                aria-labelledby="worli-tabs-tab-commondp"
                className="fade commondp tab-pane"
              >
                <div className="worli-full">
                  <div className="worli-box-title" />
                  <div className="worli-box-row">
                    <div className="worli-odd-box back">
                      <span className="worli-odd">1</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">2</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">3</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">4</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">5</span>
                    </div>
                  </div>
                  <div className="worli-box-row">
                    <div className="worli-odd-box back">
                      <span className="worli-odd">6</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">7</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">8</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">9</span>
                    </div>
                    <div className="worli-odd-box back">
                      <span className="worli-odd">0</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                role="tabpanel"
                id="worli-tabs-tabpane-colordp"
                aria-labelledby="worli-tabs-tab-colordp"
                className="fade colordp tab-pane"
              >
                <div className="worlibox">
                  <div className="worli-box-title" />
                  <div className="worli-left">
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">1</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">2</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">3</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">4</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">5</span>
                      </div>
                    </div>
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">6</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">7</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">8</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">9</span>
                      </div>
                      <div className="worli-odd-box back">
                        <span className="worli-odd">0</span>
                      </div>
                    </div>
                  </div>
                  <div className="worli-right">
                    <div className="worli-box-row">
                      <div className="worli-odd-box back">
                        <span className="worli-odd">COLOR DP ALL</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="casino-last-result-title">
            <span>Last Result</span>
            <span>
              <a href="/casino-results/worli">View All</a>
            </span>
          </div>
          <div className="casino-last-results"> */}
            <span className="result result-b">R</span>
            <span className="result result-b">R</span>
            <span className="result result-b">R</span>
            <span className="result result-b">R</span>
            <span className="result result-b">R</span>
            <span className="result result-b">R</span>
            <span className="result result-b">R</span>
            <span className="result result-b">R</span>
            <span className="result result-b">R</span>
            <span className="result result-b">R</span>
          {/* </div> */}
        </div>
      {/* </div> */}
      <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
    {/* </div> */}
  {/* </div> */}
  {/* <div className="sidebar right-sidebar casino-right-sidebar">
    <div className="sidebar-box my-bet-container">
      <div className="sidebar-title">
        <h4>My Bet</h4>
      </div>
      <div className="my-bets">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
    </div>
  </div> */}
{/* </div> */}
</CasinoPage>

  
  )
}
